module.exports = __webpack_public_path__ + "static/media/33-8.a2e7a8d9.mp3";